import React, { useEffect, useState } from 'react';
import bannerImg from "../../../template/images/ebook-banner.svg"

function EbookBanner() {
  return <>
  <div className="ebook-banner container-fluid">
    <img src={bannerImg} alt="" />
  </div>
  </>
}

export default EbookBanner;
